import Hero from '../components/Hero';
import '../styles/Pages.css';
function Java({ setCurrentPage }) {
    return (
      <>
      <Hero title="Java Development Services" image="/images/java.jpg" compact />
      <div className="page service-page">
  <div className="service-content">
          <div>
            <img src="/images/java.jpg" alt="Java Development" />
          </div>
          <div className="service-text">
            <h3>JAVA</h3>
            <p>
              One of the most generally utilized programming dialects, Java is utilized as the
              server-side language for most back-end advancement projects, including those
              including enormous information and Android improvement. Java is likewise normally
              utilized for work area registering, other versatile figuring, games, and mathematical
              processing.
            </p>
            <p>
              Java is one of the most widely used programming languages, particularly for
              server-side development in back-end projects, including those involving big data and
              Android applications. Additionally, Java is commonly utilized for desktop computing,
              mobile computing, game development, and mathematical computations.
            </p>
            <button className="cta-button" onClick={() => setCurrentPage('Contact')}>
              Get Started Today
            </button>
          </div>
        </div>
  
        <section className="about-section">
        
        </section>
      </div>
      </>
    );
  }
  
  export default Java;